// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__192iF","logo":"Login_logo__3qfaA"};